"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPlasticsTypeSchema = void 0;
const zod_1 = require("zod");
exports.SmartPlasticsTypeSchema = zod_1.z.enum(['ECP']);
exports.default = exports.SmartPlasticsTypeSchema;
//# sourceMappingURL=SmartPlasticsTypeSchema.js.map